import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Chip,
} from '@mui/material';
import {
  Logout as LogoutIcon,
  Help as HelpIcon,
  VerifiedUser as CertificateIcon,
  Download as DownloadIcon,
  Checklist as ChecklistIcon,
  Group as GroupIcon,
  ExpandMore as ExpandMoreIcon,
  Tune as TuneIcon,
  Book as BookIcon,
  Science as ScienceIcon,
  TextSnippet,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const TestingHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [helpMenuAnchor, setHelpMenuAnchor] = useState(null);
  const [isSubUser, setIsSubUser] = useState(false);

  useEffect(() => {
    // Get username from localStorage
    const storedUsername = localStorage.getItem('username') || sessionStorage.getItem('username');
    
    if (storedUsername) {
      setUsername(storedUsername);
    }

    // Check if current user is a subuser
    const subUserStatus = localStorage.getItem('isSubUser') === 'true';
    setIsSubUser(subUserStatus);
  }, [location]);
  const currentusertypeid = localStorage.getItem('userTypeId');

  const handleLogout = () => {
    // Clear user data from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('orgId');
    localStorage.clear();
    
    // Redirect to login page
    navigate('/main/login');
  };

  const handleHelp = () => {
    // Navigate to PDF viewer (view-only mode)
      window.open('/main/testing_help_manual.pdf#toolbar=0&navpanes=0&scrollbar=1', '_blank');
  };

  const handleHelpMenuOpen = (event) => {
    setHelpMenuAnchor(event.currentTarget);
  };

  const handleHelpMenuClose = () => {
    setHelpMenuAnchor(null);
  };

  const handleCreateSubUser = () => {
    handleHelpMenuClose();
    navigate('/main/testing/sub-user');
  };

  const handleHelpManual = () => {
    handleHelpMenuClose();
    // Download medical specific help manual
    const link = document.createElement('a');
    link.href = '/main/assets/medical_Laboratory_Guide.pdf';
    link.download = 'medical_Laboratory_Guide.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleChecklist = () => {
    handleHelpMenuClose();
    // Open medical specific checklist
    window.open('https://nablwpnew.qci.org.in/testing-prequisite.html', '_blank');
  };

  const handleScopeDocuments = () => {
    handleHelpMenuClose();
    // Open scope documents
    window.open('/main/medical-scope-documents', '_blank');
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #3b82f6 100%)',
        color: 'white',
        boxShadow: '0 4px 20px rgba(30, 60, 114, 0.3)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ minHeight: 64, px: 0 }}>
          {/* Brand/Logo Section */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box 
                       sx={{ 
                         display: 'flex', 
                         alignItems: 'center', 
                         cursor: 'pointer',
                         paddingY:1,
                         '&:hover': {
                           opacity: 0.9,
                         },
                         transition: 'opacity 0.3s ease',
                       }}
                       
                     >
                         <img src='/main/images/v1_9old.png' style={{width:'60px'}} alt="Logo" />
                     </Box>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontWeight: 700,
                color: 'white',
                letterSpacing: '1px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              }}
            >
              NABL
            </Typography>
          </Box>

          {/* Application Type Indicator */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {username && (
                <Box
                  sx={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '20px',
                    px: 3,
                    py: 1,
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      color: 'white',
                      textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                    }}
                  >
                    Welcome, {username}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* medical Specific Help Menu */}
            {/* <Button
              variant="outlined"
              endIcon={<ExpandMoreIcon />}
              onClick={handleHelpMenuOpen}
              sx={{
                borderColor: 'rgba(255, 255, 255, 0.5)',
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                },
                transition: 'all 0.3s ease',
                fontWeight: 600,
              }}
            >
              Medical Tools
            </Button> */}
            <Button
              sx={{
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                  },
                  transition: 'all 0.3s ease',
                  fontWeight: 600,
                }}
              variant="outlined"
              startIcon={<BookIcon />}
              onClick={handleChecklist}
              >
                Pre Checklist
              </Button>
  <Button
              sx={{
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                  },
                  transition: 'all 0.3s ease',
                  fontWeight: 600,
                }}
              variant="outlined"
              startIcon={<BookIcon />}
              onClick={handleHelp}
              >
                Help Manual
              </Button>
            {/* Only show Create Sub Users button for main users */}
            {!isSubUser && (currentusertypeid !== "4" && currentusertypeid !== "6") &&  (
              <Button
              sx={{
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                  },
                  transition: 'all 0.3s ease',
                  fontWeight: 600,
                }}
              variant="outlined"
              startIcon={<GroupIcon />}
              onClick={handleCreateSubUser}
              >
                Create Sub Users
              </Button>
            )}

            <Menu
              anchorEl={helpMenuAnchor}
              open={Boolean(helpMenuAnchor)}
              onClose={handleHelpMenuClose}
              PaperProps={{
                sx: {
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: 2,
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                  mt: 1,
                },
              }}
            >
              {/* Only show Create Sub User menu item for main users */}
              {!isSubUser && (
                <>
                  <MenuItem 
                    onClick={handleCreateSubUser}
                    sx={{
                      py: 1.5,
                      px: 3,
                      '&:hover': {
                        backgroundColor: 'rgba(30, 60, 114, 0.1)',
                      },
                    }}
                  >
                    <GroupIcon sx={{ mr: 2, color: '#1e3c72' }} />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      Create Sub User
                    </Typography>
                  </MenuItem>
                  
                  <Divider />
                </>
              )}
              
              <MenuItem 
                onClick={handleScopeDocuments}
                sx={{
                  py: 1.5,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(30, 60, 114, 0.1)',
                  },
                }}
              >
                <TuneIcon sx={{ mr: 2, color: '#1e3c72' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Scope Documents
                </Typography>
              </MenuItem>
              
              <MenuItem 
                onClick={handleHelpManual}
                sx={{
                  py: 1.5,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(30, 60, 114, 0.1)',
                  },
                }}
              >
                <DownloadIcon sx={{ mr: 2, color: '#1e3c72' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Testing Guide
                </Typography>
              </MenuItem>
              
              <MenuItem 
                onClick={handleChecklist}
                sx={{
                  py: 1.5,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(30, 60, 114, 0.1)',
                  },
                }}
              >
                <ChecklistIcon sx={{ mr: 2, color: '#1e3c72' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Testing Checklist
                </Typography>
              </MenuItem>
            </Menu>
            
            <Button
              variant="outlined"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              sx={{
                borderColor: 'rgba(255, 255, 255, 0.5)',
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                },
                transition: 'all 0.3s ease',
                fontWeight: 600,
              }}
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default TestingHeader;
